import { render, staticRenderFns } from "./BlogpostCard.vue?vue&type=template&id=c3ca9bc2&scoped=true&"
import script from "./BlogpostCard.vue?vue&type=script&lang=js&"
export * from "./BlogpostCard.vue?vue&type=script&lang=js&"
import style0 from "./BlogpostCard.vue?vue&type=style&index=0&id=c3ca9bc2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ca9bc2",
  null
  
)

component.options.__file = "BlogpostCard.vue"
export default component.exports